import axios from 'axios';
import { CATALOG_BASE_URL } from '../constants';

export interface AsFilterDef {
  key: string;
  label: string;
  placeholder: string;
}

export interface AsStatusCount {
  status: string;
  count: number;
}

export interface AsReport {
  total_records: number;
  filtered_records: number;
  date_min: string;
  date_max: string;
  date_range: [string, string];
  filters: AsFilterDef[];
  options: Record<string, string[]>;
  phases: string[];
  rows: { client: string; sub_client: string; phases: Record<string, AsStatusCount[]> }[];
  status_meta: Record<string, { label: string; color: string }>;
  raw_columns: string[];
  raw_rows: (string | number | null)[][];
}

export interface AsQuery {
  dateStart: string | null;
  dateEnd: string | null;
  selections: Record<string, string[]>;
  refresh?: boolean;
}

function queryString(q: AsQuery): string {
  const params = new URLSearchParams();
  if (q.dateStart) params.set('date_start', q.dateStart);
  if (q.dateEnd) params.set('date_end', q.dateEnd);
  Object.entries(q.selections).forEach(([key, values]) => values.forEach((v) => params.append(key, v)));
  if (q.refresh) params.set('refresh', '1');
  return params.toString();
}

export async function fetchAsReport(q: AsQuery): Promise<AsReport> {
  try {
    const response = await axios.get<AsReport>(`${CATALOG_BASE_URL}/as-workflow/report?${queryString(q)}`);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (typeof error.response?.data?.detail === 'string') throw new Error(error.response.data.detail);
      if (!error.response) throw new Error('Could not reach the backend. Is it running?');
    }
    throw new Error('Could not load the workflow data.');
  }
}

export function asCsvUrl(q: AsQuery): string {
  return `${CATALOG_BASE_URL}/as-workflow/export.csv?${queryString({ ...q, refresh: false })}`;
}
